import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Nav from './Nav';
import MobileMenu from './MobileMenu';
import Footer from './Footer';
import ScrollManager from './ScrollManager';
import useSiteInteractions from '../hooks/useSiteInteractions';

export default function Layout() {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useSiteInteractions();

  useEffect(() => {
    const cls = pathname === '/' ? 'dir-a' : 'inner';
    document.body.classList.add(cls);
    return () => document.body.classList.remove(cls);
  }, [pathname]);

  useEffect(() => {
    document.body.classList.toggle('menu-open', menuOpen);
    return () => document.body.classList.remove('menu-open');
  }, [menuOpen]);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <>
      <ScrollManager />
      <Nav menuOpen={menuOpen} onBurgerClick={() => setMenuOpen((v) => !v)} />
      <MobileMenu onLinkClick={() => setMenuOpen(false)} />
      <Outlet />
      <Footer />
    </>
  );
}
